import { URLS, PERMISSIONS } from '_constants';

const STORIES = {
  id: 4,
  title: 'stories',
  modularity: true,
  permission: [
    PERMISSIONS.VIEW_SNAPSHOT_MAPS,
    PERMISSIONS.DISPARATE_BURDEN_VIEW,
    PERMISSIONS.VIEW_ENFOCEMENT_OVERVIEW,
    PERMISSIONS.VIEW_POST_LANDSCAPE,
    PERMISSIONS.VIEW_RETAILER_REDUCTION,
    PERMISSIONS.VIEW_YOUTH_APPEAL,
  ],
  subRoutes: [
    {
      id: 1,
      title: 'snapshot maps',
      path: URLS.snapshotMaps,
      isShow: true,
      border: true,
      modularity: true,
      permission: PERMISSIONS.VIEW_SNAPSHOT_MAPS,
    },
    {
      id: 2,
      title: 'disparate burden',
      path: URLS.disparateBurden,
      isShow: true,
      devider: 'Infographics',
      modularity: true,
      // This is for short time and will be deleted when infographics will be in release
      isInfo: true,
      permission: PERMISSIONS.DISPARATE_BURDEN_VIEW,
    },
    {
      id: 3,
      title: 'enforcement overview',
      path: URLS.enforcementOverview,
      isShow: true,
      isInfo: true,
      modularity: true,
      permission: PERMISSIONS.VIEW_ENFOCEMENT_OVERVIEW,
    },
    {
      id: 4,
      title: 'point of sale landscape',
      path: URLS.posLandscape,
      isShow: true,
      isInfo: true,
      modularity: true,
      permission: PERMISSIONS.VIEW_POST_LANDSCAPE,
    },

    {
      id: 5,
      title: 'retailer reduction',
      path: URLS.retailerReduction,
      isShow: true,
      isInfo: true,
      modularity: true,
      permission: PERMISSIONS.VIEW_RETAILER_REDUCTION,
    },
    {
      id: 6,
      title: 'youth appeal',
      path: URLS.youthAppeal,
      isShow: true,
      isInfo: true,
      modularity: true,
      permission: PERMISSIONS.VIEW_YOUTH_APPEAL,
    },
  ],
  isShow: true,
};

const DASHBOARD = {
  id: 1,
  path: URLS.dashboard,
  title: 'dashboard',
  isShow: true,
};

const APP_DASHBOARD_ONLY = {
  id: 1,
  path: URLS.appDashboard,
  title: 'app dashboard',
  isShow: true,
};

const DASHBOARD_DROPDOWN = {
  id: 1,
  title: 'dashboard',
  isShow: true,
  subRoutes: [
    {
      id: 1,
      title: 'dashboard',
      path: URLS.dashboard,
      isShow: true,
    },
    {
      id: 2,
      title: 'app dashboard',
      path: URLS.appDashboard,
      isShow: true,
    },
  ],
};

const COLLECT = {
  id: 2,
  title: 'collect',
  permission: PERMISSIONS.VIEW_ASSIGNMENT || PERMISSIONS.VIEW_CAMPAIGN,
  subRoutes: [
    {
      id: 1,
      title: 'assignments',
      path: URLS.assignments,
      isShow: true,
      permission: PERMISSIONS.VIEW_ASSIGNMENT,
    },
    {
      id: 2,
      title: 'campaign list',
      path: URLS.campaign_list,
      isShow: true,
      border: true,
      permission: PERMISSIONS.VIEW_CAMPAIGN,
    },
  ],
  isShow: true,
};

const COMMON_SUBROUTES = [
  {
    id: 1,
    title: 'retailers',
    path: URLS.retailers,
    isShow: true,
    permission: PERMISSIONS.VIEW_RETAILER,
  },
  {
    id: 2,
    title: 'store merger',
    path: URLS.storeMerger,
    isShow: true,
    border: true,
    permission: PERMISSIONS.VIEW_SIMILARSTORES,
  },
  {
    id: 4,
    title: 'assessments',
    path: URLS.assessments,
    isShow: true,
    isVisit: true,
    permission: [PERMISSIONS.VIEW_VISIT, PERMISSIONS.VIEW_ASSESSMENT_VISITS],
  },
  {
    id: 5,
    title: 'education',
    path: URLS.education,
    isShow: true,
    isVisit: true,
    permission: [PERMISSIONS.VIEW_VISIT, PERMISSIONS.VIEW_EDUCATION_VISITS],
  },
  {
    id: 6,
    path: URLS.enforcement,
    isShow: true,
    isVisit: true,
    permission: [PERMISSIONS.VIEW_VISIT, PERMISSIONS.VIEW_ENFORCEMENT_VISITS],
  },
  {
    id: 7,
    title: 'reports',
    path: URLS.reports,
    isShow: true,
    borderAll: true,
    modularity: true,
    permission: [
      PERMISSIONS.VIEW_SUMMARY_REPORT_AREA,
      PERMISSIONS.VIEW_REPORT_ENFORCEMENT_OVERVIEW,
      PERMISSIONS.VIEW_REPORT_EDUCATION_OVERVIEW,
    ],
  },
  {
    id: 8,
    title: 'venues',
    path: URLS.venues,
    isShow: true,
    border: true,
    permission: PERMISSIONS.VIEW_VENUE,
  },
  {
    id: 9,
    title: 'youth',
    path: URLS.youth,
    isShow: true,
    permission: PERMISSIONS.VIEW_YOUTH_LINK,
  },
  {
    id: 10,
    title: 'audit logs',
    path: URLS.auditLogs,
    isShow: true,
    permission: PERMISSIONS.VIEW_AUDIT_LOG,
  },
  {
    id: 11,
    title: 'county courts list',
    path: URLS.countyCourtsList,
    isShow: true,
    permission: PERMISSIONS.VIEW_COUNTY_COURTS_LIST,
  },
];

const getDataRoutes = (isAzAccount = false) => ({
  id: 3,
  title: 'data',
  isShow: true,
  subRoutes: COMMON_SUBROUTES.map((route) => {
    if (route.id === 6) {
      return {
        ...route,
        title: isAzAccount ? 'inspections' : 'enforcement',
      };
    }
    return route;
  }),
});

const USERS = {
  id: 5,
  title: 'users',
  path: URLS.users,
  isShow: true,
  permission: PERMISSIONS.VIEW_USER,
};

const HELP = {
  id: 6,
  title: 'help',
  subRoutes: [],
  isShow: true,
};

const EMAIL = {
  id: 7,
  title: 'email',
  subRoutes: [
    {
      id: 1,
      title: 'login as user',
      path: URLS.logout,
      permission: PERMISSIONS.LOGIN_AS_USER,
      isShow: true,
    },
    {
      id: 2,
      title: 'log out',
      path: URLS.logout,
      isShow: true,
    },
  ],
  isShow: true,
};

const LOGIN = {
  id: 8,
  title: 'Login',
  path: URLS.login,
  isShow: true,
};

const PUBLIC_SUB_ROUTES = [
  {
    id: 1,
    title: 'snapshot maps',
    path: URLS.snapshotMaps,
    isShow: true,
    border: true,
    modularity: true,
    permission: PERMISSIONS.VIEW_SNAPSHOT_MAPS,
  },
  {
    id: 2,
    title: 'disparate burden',
    path: URLS.disparateBurden,
    isShow: true,
    devider: 'Infographics',
    modularity: true,
    isInfo: true, // temporary until infographics release
    permission: PERMISSIONS.DISPARATE_BURDEN_VIEW,
  },
  {
    id: 3,
    title: 'enforcement overview',
    path: URLS.enforcementOverview,
    isShow: true,
    isInfo: true,
    modularity: true,
    permission: PERMISSIONS.VIEW_ENFOCEMENT_OVERVIEW,
  },
  {
    id: 4,
    title: 'point of sale landscape',
    path: URLS.posLandscape,
    isShow: true,
    isInfo: true,
    modularity: true,
    permission: PERMISSIONS.VIEW_POST_LANDSCAPE,
  },
  {
    id: 5,
    title: 'retailer reduction',
    path: URLS.retailerReduction,
    isShow: true,
    isInfo: true,
    modularity: true,
    permission: PERMISSIONS.VIEW_RETAILER_REDUCTION,
  },
  {
    id: 6,
    title: 'youth appeal',
    path: URLS.youthAppeal,
    isShow: true,
    isInfo: true,
    modularity: true,
    permission: PERMISSIONS.VIEW_YOUTH_APPEAL,
  },
];

const AZ_PUBLIC_ACCESS = {
  id: 9,
  title: 'public access',
  modularity: true,
  isShow: true,
  subRoutes: [
    ...PUBLIC_SUB_ROUTES,
    {
      id: 7,
      title: 'Map View',
      path: URLS.retailers_public,
      isShow: true,
    },
  ],
};

const PUBLIC_ACCESS = {
  id: 9,
  title: 'public access',
  modularity: true,
  isShow: true,
  permission: PUBLIC_SUB_ROUTES.map((route) => route.permission).filter(Boolean),
  subRoutes: PUBLIC_SUB_ROUTES,
};

const getDashboardInfoSections = (dashboardInfoSections) =>
  dashboardInfoSections.map(({ title, link }, index) => ({
    id: index + 1,
    title,
    path: link,
    isShow: true,
    isHelp: true,
    href: link.includes('@') ? `mailto:${link}` : link,
  }));

export const getMenuRoutes = (
  isAuthenticated,
  userEmail = 'email',
  isOffline = false,
  dashboardInfoSections = [],
  isAzAccount = false,
  canAccessAppDashboard = false,
  isAppDashboardOnlyUser = false,
) => {
  const PUBLIC_LINKS = isAzAccount ? AZ_PUBLIC_ACCESS : PUBLIC_ACCESS;
  const DATA_ROUTE = getDataRoutes(isAzAccount);
  // P20M-1309 — the App Dashboard link shows only to users who can actually
  // open it: superusers, or staff granted at least one section permission —
  // on any viewport width.
  const hasDashboardDropdown = canAccessAppDashboard;
  // P20M-1327 — a viewer with no tenant permissions (GovRAMP-only Visitor) gets
  // a single direct link: the tenant Dashboard is empty for them and would only
  // redirect back, so it is not offered at all.
  const appDashboardOnly = canAccessAppDashboard && isAppDashboardOnlyUser;
  const dashboardRoute = appDashboardOnly ? APP_DASHBOARD_ONLY : hasDashboardDropdown ? DASHBOARD_DROPDOWN : DASHBOARD;

  const authenticatedRoutes = [
    dashboardRoute,
    COLLECT,
    DATA_ROUTE,
    STORIES,
    USERS,
    { ...HELP, subRoutes: getDashboardInfoSections(dashboardInfoSections) },
  ];

  authenticatedRoutes.push({ ...EMAIL, title: userEmail });

  // Offline: only assignments/survey data is available, so hide the campaign list sub-route.
  const OFFLINE_COLLECT = {
    ...COLLECT,
    subRoutes: COLLECT.subRoutes.filter((route) => route.path !== URLS.campaign_list),
  };

  return isAuthenticated
    ? isOffline
      ? [OFFLINE_COLLECT, { ...EMAIL, title: userEmail }]
      : authenticatedRoutes
    : [PUBLIC_LINKS, LOGIN];
};
